<template>
  <span
    @click="selectStep"
    :class="['step-item', stepIndex === currentStepIndex ? 'active-class' : '']"
  >
    <el-badge
      :type="badgeStatus"
      :value="stepIndex + 1"
      :class="[isChanged ? 'changed' : '']"
    />
    {{ step.title }}
  </span>
</template>

<script>
export default {
  name: 'PageStep',

  props: {
    step: {
      type: Object,
      required: true
    },

    stepIndex: {
      type: Number,
      required: true
    },

    currentStepIndex: {
      type: Number,
      required: true
    },

    previousStepAllowed: {
      type: Boolean,
      required: true
    },
    isChanged: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  computed: {
    badgeStatus() {
      if (this.step.completed && this.currentStepIndex !== this.stepIndex) {
        return 'success'
      } else if (this.currentStepIndex === this.stepIndex) {
        return 'primary'
      } else {
        return 'info'
      }
    }
  },

  methods: {
    selectStep() {
      this.$emit('select-step', this.stepIndex)
    }
  }
}
</script>

<style scoped>
.step-item {
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: #7e8596;
}

.active-class {
  color: #1d87c8;
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  border-bottom: 0 none;
  border-radius: 4px 4px 0 0;
  margin-bottom: -1px;
}

.el-badge {
  margin-right: 5px;
  display: flex;
}

>>> .el-badge__content--primary {
  background-color: #1c87c8;
}
>>> .changed > .el-badge__content {
  background-color: #c81d87;
}
</style>



// WEBPACK FOOTER //
// src/common/components/page/PageStep.vue